import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { activeSite } from './website/sites';

// Umami Analytics — fest auf die selbst gehostete Instanz verdrahtet.
// data-domains hält Zugriffe aus der Entwicklung heraus; es zählt ausschließlich
// unter den hier genannten Hosts. Deshalb muss jede Kundendomain mit drin stehen,
// sonst hört die Messung mit einer Domain-Umstellung schlagartig auf.
//
// optivisit.gsk-it.de steht hier seit dem 31.08.2026 bewusst NICHT mehr: Seit
// dem Live-Gang der Kundendomain ist das nur noch die Vorschau- und
// Ausweichadresse, und die Arbeit der eigenen Leute darin hätte die Zahlen des
// Kunden verfälscht. Wer dort etwas prüft, taucht in der Statistik nicht auf.
const umamiUrl = 'https://umami.gsk-it.de';

/**
 * Jeder Auftritt zählt in seine eigene Umami-Website; welche, steht in
 * `sites.json` neben Hosts, Routen und Icons.
 *
 * Bewusst dort und nicht in einer Umgebungsvariablen: Coolify übernimmt die
 * Vorgabewerte aus der Compose-Datei nicht, eine nicht gesetzte Variable fiele
 * hier still auf die falsche Website zurück — und niemand bemerkt eine
 * Statistik, die zwar Zahlen zeigt, aber die falschen.
 */
const umamiWebsiteId = activeSite().umamiWebsiteId;

if (umamiUrl && umamiWebsiteId) {
  const script = document.createElement('script');
  script.defer = true;
  script.src = `${umamiUrl}/script.js`;
  script.dataset.websiteId = umamiWebsiteId;
  script.dataset.domains =
    'www.sb-antczak.de,sb-antczak.de,miteinander38.de,www.miteinander38.de';
  // Keine automatische Zählung: Die interne Anwendung liegt im selben Router,
  // und ihre Routen sind nicht an einen Host gebunden. Umami würde sonst
  // /dashboard, /anfragen und /select-system als Website-Besuche zählen.
  // Gezählt wird ausschließlich in den Rahmen der öffentlichen Auftritte,
  // siehe website/useUmamiPageview.ts.
  script.dataset.autoTrack = 'false';
  document.head.appendChild(script);
}

const container = document.getElementById('root') as HTMLElement;
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/**
 * Die öffentlichen Seiten kommen vorgerendert vom Server (`scripts/prerender.js`):
 * `#root` ist dann schon voll. Diesen DOM übernimmt React (hydrieren), statt ihn
 * wegzuwerfen und alles neu zu malen — Letzteres war der Grund, warum Google auf
 * dem Telefon ein LCP von 4,5 s maß, obwohl der Text nach 1,1 s da war: Der zweite
 * Anstrich nach dem Laden der 400 KB JavaScript zählte als „größter Inhalt".
 *
 * Damit die Übernahme gelingt, muss der erste Render im Browser dem des
 * Prerenderings gleichen; deshalb legt das Bauskript die Kundentexte als
 * `window.__SITE_CONTENT__` in jede Seite. Passt trotzdem etwas nicht, fällt
 * React 18 von selbst auf einen vollständigen Neu-Render zurück — also auf den
 * Stand von vorher, nie auf eine kaputte Seite.
 *
 * Die interne Anwendung (`/login`, `/dashboard` …) bekommt die leere Hülle aus
 * `index.html`; dort bleibt es beim gewöhnlichen Rendern.
 */
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}